module.exports = __webpack_public_path__ + "static/img/4.2aece31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/4.jpg
// module id = A6MY
// module chunks = 1